export default __webpack_public_path__ + "static/media/logo1024x1024.68faded3.png";